/**
 * /app/$tenantSlug/performance/my-results — the employee's own results
 * from closed review cycles (2026-10). Me surface (the Performance module
 * strip carries the nav entry); every employee with the performance
 * feature sees it — the API is self-scoped.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { MyResultsList } from "@/components/performance/my-results";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/my-results/",
)({
  component: MyResultsRoute,
});

function MyResultsRoute() {
  return (
    <PerformanceModuleShell
      title="Results"
      description="Your final rating and your manager's review from each closed review cycle."
    >
      <PerformanceFeatureGate>
        <MyResultsList />
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
